import { render, staticRenderFns } from "./TableHomeworkUploadDataList.vue?vue&type=template&id=b5ad73b6&scoped=true"
import script from "./TableHomeworkUploadDataList.vue?vue&type=script&lang=js"
export * from "./TableHomeworkUploadDataList.vue?vue&type=script&lang=js"
import style0 from "./TableHomeworkUploadDataList.vue?vue&type=style&index=0&id=b5ad73b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ad73b6",
  null
  
)

export default component.exports